import CodeShareIcon from "./CodeShareIcon";
import LowCostIcon from "./LowCostIcon";
import React from "react";
import { ConfigSliceState, selectConfig } from "../../config/ConfigSlice";
import { useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { selectSearchFlightsForm } from "../searchFlightsSlice";

function SearchFlightsResultsLegend() {
  const { t } = useTranslation();
  const form = useAppSelector(selectSearchFlightsForm);
  const { mapper }: ConfigSliceState = useAppSelector(selectConfig);
  return (
    <div className="legend">
      {form.includeCodeShare && (
        <span className="p-1">
          <CodeShareIcon />
          <abbr className="pl-1 is-size-7" title={t("OAG_CODESHARE_INDICATOR")}>
            {t("CODE_SHARE")}
          </abbr>
        </span>
      )}
      {mapper.enableLowCostIndicator && (
        <span className="p-1">
          <LowCostIcon />
          <abbr className="pl-1 is-size-7" title={t("OAG_LOWCOST_DISCLAIMER")}>
            {t("OAG_LOWCOST_DISCLAIMER_HEADER")}
          </abbr>
        </span>
      )}
    </div>
  );
}

export default SearchFlightsResultsLegend;
